import { useEffect, useState } from "react"
import { useProgress } from "@react-three/drei"
import { AnimatePresence, motion } from "framer-motion"
import loadingAnimation from '../data/loadingAnimation.json'
import Lottie from "lottie-react";
import { useStore } from "../store"
import {RedwoodPalette as colors } from "../data/constants";

function Loader() {
  const { active } = useProgress()
  const isLoading = useStore((state) => state.isLoading)
  const [showLoader, setShowLoader] = useState(false)
  const setIsLoading = useStore((state) => state.setIsLoading)

  const lottieStyle = {
    height: 100,
    width: 100
  }
  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setIsLoading(active)
    }, 2000)

    return () => {
      clearTimeout(loadingTimeout)
    }
  }, [active, setIsLoading])

  useEffect(() => {
    const showLoaderTimeout = setTimeout(() => {
      setShowLoader(true)
    }, 500)

    return () => {
      clearTimeout(showLoaderTimeout)
    }
  }, [])

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
    }}>
      <AnimatePresence>
        {isLoading && (
          <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              delay: 0.3,
            }}
            style={{
              background: '#D7D7D7',
              width: '100vw',
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              color: colors.neutralGrey190,
              fontSize: '30px',
              fontFamily: 'Oracle Sans',
            }}
          >
            <div style={{
              maxWidth: '1440px',
              margin: '0 auto',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              width: '100vw'
            }}>
              {showLoader && <Lottie animationData={loadingAnimation} style={lottieStyle} aria-label="Loading"/>}
              {showLoader}
            </div>
          </motion.div>
        )}
        </AnimatePresence>
      </div>
  )
}

export { Loader }
